export class NotificationCountModel {
    actionRequired?: any = null;
    actionRequiredCount ? = 0;
    awaitingResponseFromBHP?: any = null;
    invitationToBidAvailable?: any = null;
    awaitingResponseFromBHPCount ? = 0;
    invitationToBidAvailableCount ? = 0;
    totalNotificationsCount ? = 0;

    constructor(notification) {
        {
            if (notification){
                this.actionRequired = notification.actionRequired || null;
                this.actionRequiredCount = notification.actionRequiredCount || 0;
                this.awaitingResponseFromBHP = notification.awaitingResponseFromBHP || null;
                this.invitationToBidAvailable = notification.invitationToBidAvailable || null;
                this.awaitingResponseFromBHPCount = notification.awaitingResponseFromBHPCount || 0;
                this.invitationToBidAvailableCount = notification.invitationToBidAvailableCount || 0;
                this.totalNotificationsCount = notification.totalNotificationsCount || 0;
            }
        }
    }
}








actionRequired: "Action Required"
actionRequiredCount: 0
awaitingResponseFromBHP: "Awaiting respone from BHP"
awaitingResponseFromBHPCount: 1
totalNotificationsCount: 1

